import React from 'react'
import NumberFormat from 'react-number-format'
import { useTranslation } from '../hooks/useTranslation';

function ProductPriceComponent({ product, multiply = null }) {
    const { t } = useTranslation();

    const getPriceAfterDiscount = () => {
        return product.productPriceAfterDiscount ?? product.productPrice;
    }

    const price = (multiply != null) ? (getPriceAfterDiscount() * multiply) : (getPriceAfterDiscount());
    return (
        <div className='price'>
            <NumberFormat
                role="application"
                aria-roledescription={t("Price")}
                aria-label={(price) + (product.currencyCode ? product.currencyCode.replace("ILS", "₪").replace("USD", "$") : product.currencyCode)}
                value={price}
                displayType={'text'}
                thousandSeparator={true}
                prefix={product.currencyCode ? product.currencyCode.replace("ILS", "₪").replace("USD", "$") : product.currencyCode}
            />
        </div>

    )
}

export default ProductPriceComponent